// filter filesize
// Vue.filter('filesize', function(bytes) {
//     if (bytes === 0) return '0 B'
//     const k = 1024
//     const sizes = ['B', 'KB', 'MB']
//     const i = Math.floor(Math.log(bytes) / Math.log(k))
//     return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
// })

export default function filesize(bytes) {
    if (bytes === 0) return '0 B'
    const k = 1024
    const sizes = ['B', 'KB', 'MB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
}